import baseAxios from "axios";

// Environment: DEV | STAGING | PROD
const ENV = process.env.REACT_APP_ENV || "DEV";

const configUrls = {
  DEV: {
    MAIN_LAMBDA_URL: "http://192.168.0.90:5000/api/v1",
    ZIKHARA_API_URL: "http://192.168.0.90:5000/api/v1",
    SCRIPT_URL: "https://openai.thezikhara.com/",
    AUTOMATED_VO_URL: "https://4qmyt8eh78.execute-api.ap-south-1.amazonaws.com/dev",
    PIANOSA_APP_V2_MAPPING: "https://app-api.thezikhara.com/api/v1",
    DOCUMENT_BASE_URL: "https://d20vmeuwl3jwbk.cloudfront.net/",
    MUI_LICENSE_KEY:
      "04da816e1a0ab207b261370c95321bf9Tz0xMDUyMTQsRT0xNzY5ODUzMDk2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
  },
  STAGING: {
    MAIN_LAMBDA_URL: "https://7wkmy756b1.execute-api.ap-south-1.amazonaws.com",
    ZIKHARA_API_URL: "https://staging-apis.thezikhara.com/api/v1",
    SCRIPT_URL: "https://openai.thezikhara.com/",
    AUTOMATED_VO_URL: "https://4qmyt8eh78.execute-api.ap-south-1.amazonaws.com/dev",
    PIANOSA_APP_V2_MAPPING: "https://app-api.thezikhara.com/api/v1",
    DOCUMENT_BASE_URL: "https://d20vmeuwl3jwbk.cloudfront.net/",
    MUI_LICENSE_KEY:
      "04da816e1a0ab207b261370c95321bf9Tz0xMDUyMTQsRT0xNzY5ODUzMDk2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
  },
  PROD: {
    MAIN_LAMBDA_URL: "https://jpirxj2umf.execute-api.ap-south-1.amazonaws.com",
    ZIKHARA_API_URL: "https://api.thezikhara.com/api/v1",
    SCRIPT_URL: "https://openai.thezikhara.com/",
    AUTOMATED_VO_URL: "https://4qmyt8eh78.execute-api.ap-south-1.amazonaws.com/dev",
    PIANOSA_APP_V2_MAPPING: "https://app-api.thezikhara.com/api/v1",
    DOCUMENT_BASE_URL: "https://d2j4mq1p9yw66c.cloudfront.net/",
    MUI_LICENSE_KEY:
      "04da816e1a0ab207b261370c95321bf9Tz0xMDUyMTQsRT0xNzY5ODUzMDk2MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=",
  },
};

// Utility: Create axios instance with interceptors
const createAxios = (baseURL) => {
  const instance = baseAxios.create({
    baseURL,
    headers: { "Content-Type": "application/json" },
  });

  instance.interceptors.request.use((config) => {
    const token = localStorage.getItem("x_acess_token");
    if (token) config.headers.x_acess_token = token;
    return config;
  });

  instance.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error?.response?.status === 401) {
        ["x_acess_token", "user", "roleCode"].forEach((key) =>
          localStorage.removeItem(key)
        );
      }
      return Promise.reject(error);
    }
  );

  return instance;
};

// Axios instances
export const axios = createAxios(configUrls[ENV].MAIN_LAMBDA_URL);
export const hraxios = createAxios(configUrls[ENV].ZIKHARA_API_URL);
export const scriptaxios = createAxios(configUrls[ENV].SCRIPT_URL);
export const automatedVoaxios = createAxios(configUrls[ENV].AUTOMATED_VO_URL);
export const pianosaaxios = createAxios(configUrls[ENV].PIANOSA_APP_V2_MAPPING);

// Document base URL & License key
export const docBaseUrl = configUrls[ENV].DOCUMENT_BASE_URL;
export const muiLicenseKey = configUrls[ENV].MUI_LICENSE_KEY;